import React, { useState, useMemo } from "react";
import {
  CreditCardOff,
  ErrorOutline,
  Subscriptions,
} from "@mui/icons-material";
import { Button } from "antd";
import SubscriptionModal from "../subscription-modal";
import http from "../../services/http";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import "./styles.scss";

function RenewSubscription({ subscription }) {
  // STATES
  const [manageLoader, setmanageLoader] = useState(false);

  // STATES
  const [subscriptionPreview, setSubscriptionPreview] = useState(false);

  // CONST VALS
  const requiresPaymentUpdate =
    subscription?.payment_status === "requires_payment_method";
  const paymentDueUpdate = subscription?.status === "past_due";
  const subscriptionDue = paymentDueUpdate || requiresPaymentUpdate;

  const { cardClass, Icon, title, message, ctaLabel } = useMemo(() => {
    if (requiresPaymentUpdate) {
      return {
        cardClass: "subscribe-card--payment",
        Icon: CreditCardOff,
        title: "Payment method needed",
        message:
          "We could not charge your card. Add a valid payment method to keep access to all features.",
        ctaLabel: "Update payment method",
      };
    }
    if (paymentDueUpdate) {
      return {
        cardClass: "subscribe-card--past-due",
        Icon: ErrorOutline,
        title: "Payment did not go through",
        message:
          "Your last payment failed. Update your billing details so your subscription stays active.",
        ctaLabel: "Update payment method",
      };
    }
    return {
      cardClass: "subscribe-card--expired",
      Icon: Subscriptions,
      title: "Your subscription has ended",
      message:
        "Renew to continue using datasets, exports, and the rest of your workspace.",
      ctaLabel: "Renew subscription",
    };
  }, [requiresPaymentUpdate, paymentDueUpdate]);

  // HANDLERS
  const manageSubscription = () => {
    if (manageLoader) return;
    setmanageLoader(true);
    http
      .get("subscription-session")
      .finally(() => setmanageLoader(false))
      .then(({ data }) => {
        window.location.href = data.url;
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  return (
    <div className="renew-subscription-wrapper">
      <div className={`subscribe-card ${cardClass}`}>
        <div className="subscribe-card__accent" aria-hidden />
        <div className="thumb">
          <Icon />
        </div>
        <h2 className="subscribe-card__title">{title}</h2>
        <p className="subscribe-card__message">{message}</p>
        <div className="action-btns">
          <Button
            type="primary"
            size="large"
            block
            className="subscribe-card__cta"
            onClick={
              subscriptionDue ? manageSubscription : () => setSubscriptionPreview(true)
            }
          >
            {manageLoader ? (
              <BeatLoader size={8} color="#1a1a1a" />
            ) : (
              ctaLabel
            )}
          </Button>
        </div>
      </div>
      <SubscriptionModal
        preview={subscriptionPreview}
        closeHandler={() => setSubscriptionPreview(false)}
      />
    </div>
  );
}

export default RenewSubscription;
